'use strict';

module.exports = function emoji_html(tokens, idx
/*, options, env */
) {
  return tokens[idx].content;
};